import { lazy, Suspense } from 'react';

const JobPreview = lazy(() => import('./JobPreview').then((module) => ({ default: module.JobPreview })));

export const JobPreviewLazy = () => {
  return (
    <Suspense fallback={<div>loading...</div>}>
      <JobPreview />
    </Suspense>
  );
};
